"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    // 外部弹窗可见性
    visible: {
      type: Boolean,
      defaulr: false
    }
  },
  data: function data() {
    return {
      productStatus: [{}],
      pageName: 'retailStoresInfo.form.product',
      /** enum */
      optConfig: {
        vehicles: [],
        // 产品车型
        rimSize: [],
        // 轮胎尺寸
        pattern: [] // 产品花纹
      },
      /** form */
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        vehicles: [],
        // 产品车型
        rimSize: [],
        // 轮胎尺寸
        pattern: [],
        // 产品花纹
        tyreSize: '' // 产品规格
      },
      lookupList: {},
      list: []
    };
  },
  watch: {
    // '$store.getters.language': {
    //   handler(newValue) {
    //     // 监听语言变更重新请求配置查询接口
    //     this.queryProductSelect()
    //   }
    // }
    visible: {
      deep: true,
      immediate: true,
      handler: function handler(val, oldVal) {
        if (val && val !== oldVal) {
          this.initView();
        }
      }
    }
  },
  mounted: function mounted() {
    // this.queryProductSelect()
    // this.searchData()
  },
  methods: {
    // 初始化页面
    initView: function initView() {
      this.queryProductSelect();
      this.fetchData();
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();

      // 规格搜索内容不能少于5位
      if (this.searchVal.tyreSize && this.searchVal.tyreSize.length < 5) {
        this.$message.error(this.$t('retailStoresInfo.form.product.error.specification'));
        return;
      }
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({
          retailorStoreInfoPk: this.$route.query.retailorStoreInfoPk
        }, this.searchVal)
      };
      this.listLoading = true;
      this.$api.retailorStore.getProductList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    queryProductSelect: function queryProductSelect() {
      var _this2 = this;
      var param = {
        retailorStoreInfoPk: this.$route.query.retailorStoreInfoPk
      };
      this.$api.retailorStore.getProductSelect(param).then(function (res) {
        var _ref = res.data || {},
          vehicles = _ref.vehicles,
          rimSize = _ref.rimSize,
          pattern = _ref.pattern;
        _this2.optConfig.vehicles = vehicles || []; // 产品车型
        _this2.optConfig.rimSize = rimSize || []; // 轮胎尺寸
        _this2.optConfig.pattern = pattern || []; // 产品花纹
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    resetData: function resetData() {
      this.searchVal = this.$options.data().searchVal;
      this.fetchData();
    },
    editDetails: function editDetails(row) {
      this.$router.push({
        path: '/productModule/retailStoresInfo.form.product/productDetails',
        query: {
          productInfoPk: row.productInfoPk
        }
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    }
  }
};